/** Read a non-httpOnly cookie. Only `tb_csrf` is readable by design; the refresh cookie is httpOnly. */
export function readCookie(name: string, source?: string): string | null {
  const jar = source ?? (typeof document === 'undefined' ? '' : document.cookie);
  for (const part of jar.split(';')) {
    const [rawKey, ...rest] = part.trim().split('=');
    if (rawKey === name) return decodeURIComponent(rest.join('='));
  }
  return null;
}
